angular.module('invoice')
    .component('invoiceSubstantiveDescription', {
        bindings: {
            invoiceId: '<',
            invoicePricing: '<',
            disabled: '<'
        },
        templateUrl: 'app/invoice/substantive-description-show.html',
        controller: function ($scope, Invoice, InvoiceConst, InvoiceService, InvoiceSubstantiveDescriptionService) {
            this.InvoiceSubstantiveDescriptionService = InvoiceSubstantiveDescriptionService
            this.InvoiceService = InvoiceService

            this.$onChanges = () => {
                Invoice.substantiveDescription({id: this.invoiceId}).$promise.then(result => {
                    this.item = result.substantiveDescription
                    this.costs = result.costs
                    this.totalCosts = InvoiceService.sum(this.costs.map(cost => cost.price))
                }).catch(() => {
                    this.costs = []
                    this.totalCosts = InvoiceService.sum(this.costs.map(cost => cost.price))
                })
            }

            $scope.$on(InvoiceConst.eventUpdate, () => this.$onChanges())

            this.isAccuratePercentage = (value) => {
                let value1 = Math.round(value * 100) / 100
                let value2 = Math.round(value)
                return value1 === value2
            }
        }
    })
